module.exports = __webpack_public_path__ + "f0ba795214f1cc547f96eb7e1d58870f.json";


//////////////////
// WEBPACK FOOTER
// ./src/portal/i18n/ja.json
// module id = 1148
// module chunks = 0